import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useHostAuth } from "@/contexts/HostAuthContext";
import { toast } from "sonner";
import { Crown, SignIn } from "@phosphor-icons/react";

export default function HostLogin() {
  const { login } = useHostAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/host/console", { replace: true });
    } catch (e2) {
      toast.error(e2.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-nk-bg text-nk-text flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="inline-flex items-center gap-2 text-nk-gold mb-2">
            <Crown size={18} weight="fill" />
            <span className="font-mono text-xs uppercase tracking-[0.2em]">NKognito Live</span>
          </div>
          <h1 className="font-display text-3xl font-medium">Host login</h1>
          <p className="text-sm text-nk-mute mt-1">Enter your credentials to open the Host Console.</p>
        </div>

        <form onSubmit={submit} className="nk-card p-6 space-y-4" data-testid="host-login-form">
          <div>
            <label className="block text-xs text-nk-mute mb-1">Email</label>
            <input
              data-testid="host-login-email"
              type="email"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 rounded-sm border border-nk-line bg-nk-charcoal text-sm focus:border-nk-gold outline-none"
              placeholder="you@yourorg.com"
            />
          </div>
          <div>
            <label className="block text-xs text-nk-mute mb-1">Password</label>
            <input
              data-testid="host-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded-sm border border-nk-line bg-nk-charcoal text-sm focus:border-nk-gold outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="host-login-submit"
            className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-sm bg-nk-gold text-nk-bg font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
          >
            <SignIn size={16} weight="bold" />
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="text-xs text-nk-mute text-center mt-6">
          Don&apos;t have an account? NKognito Live is invite-only — ask an admin for a setup link.
        </p>
      </div>
    </div>
  );
}
